import { BOM_TABLES_ENUM } from '../../shared/constants';

export const priceRelatedCols = new Set([BOM_TABLES_ENUM.COST, BOM_TABLES_ENUM.DISCOUNT, BOM_TABLES_ENUM.DISCOUNT_COST, BOM_TABLES_ENUM.MARGIN, BOM_TABLES_ENUM.SELL_PRICE, BOM_TABLES_ENUM.PER]);

export const serviceRelatedCols = new Set(['magnitude']);

export const pricingBodInfoCols = new Set([
    BOM_TABLES_ENUM.QUOTE_NOTES,
    BOM_TABLES_ENUM.INTERNAL_COMMENTS,
    BOM_TABLES_ENUM.LOT,
    BOM_TABLES_ENUM.LEAD_TIME_UNIT,
    BOM_TABLES_ENUM.LEAD_TIME_VALUE,
    BOM_TABLES_ENUM.QUOTE_NO
]);
export const bomCols = new Set([
    BOM_TABLES_ENUM.TYPE,
    BOM_TABLES_ENUM.QTY,
    BOM_TABLES_ENUM.MANUFACTURER,
    BOM_TABLES_ENUM.MODEL_NO,
    BOM_TABLES_ENUM.PRODUCT_FINDER,
    BOM_TABLES_ENUM.SPECIFICATION,
    BOM_TABLES_ENUM.DESCRIPTION,
    BOM_TABLES_ENUM.PRODUCT_TO_REPLACE
]);

export enum CALC_METHODS {
    FLAT_FEE = 'flat_fee',
    PERCENTAGE_OF_ORDER = 'percentage_of_order',
    FREIGHT_EXCLUDED = 'freight_excluded'
}

export const toolBaroptions = ['createSection', 'delete', 'search', 'hide', 'unhide', 'selectedItems', 'duplicate', 'move', 'createKit', 'highlight', 'bulkEdit'];
export const BULK_EDIT_OPTIONS = [
    'qty',
    'qtyPer',
    'manufacturer',
    'specification',
    'lot',
    'productToReplace',
    'cost',
    'discount',
    'discountedCost',
    'margin',
    'sellPrice',
    'leadTimeUnit',
    'leadTimeValue',
    'quoteNo',
    'externalNotes',
    'internalComments'
];

export const qtyParams = { params: { format: 'N', decimals: 0, validateDecimalOnType: true } };
export const BULK_EDIT_FIELD_NAMES: { [key: string]: string } = {
    margin: 'Margin (%)',
    sellPrice: 'Sell Price',
    discount: 'Discount (%)',
    discountedCost: 'Discounted Cost'
};

export enum LEAD_TIME_UNITS {
    DAYS = 'Days',
    WEEKS = 'Weeks',
    MONTHS = 'Months',
    YEARS = 'Years',
    IN_STOCK = 'In Stock',
    WORKING_DAYS = 'Working Days'
}

export interface IOptions {
    [index: string]: string;
}
export const COLUMN_OPTIONS_PL_TAB = {
    data: [
        { label: 'Type', field: 'category' },
        { label: 'Qty', field: 'qty' },
        { label: 'Model Number', field: 'model_number' },
        { label: 'Product Finder', field: 'productFinder' },
        { label: 'Manufacturer', field: 'manufacturer' },
        { label: 'Quote Notes', field: 'quoteNotes' },
        { label: 'Specification', field: 'specification' },
        { label: 'Description', field: 'description' },
        { label: 'Lot', field: 'lotId' },
        { label: 'Cost', field: 'cost' },
        { label: 'Discount(%)', field: 'discount' },
        { label: 'Discounted Cost', field: 'discountedCost' },
        { label: 'Ext. Discounted Cost', field: 'extendedDiscountCost' },
        { label: 'Margin(%)', field: 'margin' },
        { label: 'Sell Price', field: 'sellPrice' },
        { label: 'Ext. Sell Price', field: 'extendedPrice' },
        { label: 'Ext. Cost', field: 'extendedCost' },
        { label: 'Lead Time Unit', field: 'leadTimeUnit' },
        { label: 'Lead Time Value', field: 'leadTimeValue' },
        { label: 'Source Quotes Number', field: 'quoteNo' },
        { label: 'Per', field: 'per' },
        { label: 'Product To Replace', field: 'replaceProductId' },
        { label: 'Internal Comments', field: 'internalComments' },
        { label: 'Pricing History ', field: 'history' },
        { label: 'Add/Deduct Amount', field: 'addDeductAmount' }
    ]
} as const;
export const COLUMN_OPTIONS_BOM_TAB = {
    data: [
        { label: 'Type', field: 'category' },
        { label: 'Qty', field: 'qty' },
        { label: 'Model Number', field: 'model_number' },
        { label: 'Manufacturer', field: 'manufacturer' },
        { label: 'Specification', field: 'specification' },
        { label: 'Product Finder', field: 'productFinder' },
        { label: 'Description', field: 'description' },
        { label: 'Product To Replace', field: 'product_to_replace' }
    ]
} as const;
export const COLUMN_OPTIONS_DATASHEET_TAB = {
    data: [
        { label: 'Type', field: 'category' },
        { label: 'Qty', field: 'qty' },
        { label: 'Manufacturer', field: 'manufacturer' },
        { label: 'Model Number', field: 'model_number' },
        { label: 'Notes', field: 'notes' },
        { label: 'Datasheet', field: 'datasheet' },
        { label: 'Annotations', field: 'annotations' }
    ]
} as const;
export const COLUMN_OPTIONS_OM_TAB = {
    data: [
        { label: 'Type', field: 'category' },
        { label: 'Qty', field: 'qty' },
        { label: 'Manufacturer', field: 'manufacturer' },
        { label: 'Model Number', field: 'model_number' },
        { label: 'Notes', field: 'notes' },
        { label: 'Datasheet', field: 'datasheet' },
        { label: 'Installation Guide', field: 'installationGuide' },
        { label: 'Drawing', field: 'drawing' },
        { label: 'Warranty', field: 'warranty' },
        { label: 'Other Document', field: 'otherDocument' }
    ]
} as const;

export const DISCOUNT_DISCOUNT_COST_MARGIN_TOOLTIP_MSG = 'A cost entry is required in order to enter a discount and/or margin.';
export const EXTENDED_SELL_TOOLTIP_MSG = 'Extended Sell Price is auto-calculated based on Qty, Cost, Discount and Margin.';
export const EXTENDED_DISC_COST_TOOLTIP_MSG = 'Extended Discounted Cost is auto-calculated based on Qty, Cost, Discount and Margin.';
export const KIT_LINE_TOOLTIP_MSG = 'These fields are auto-calculated to reflect the contents of this kit.';
export const COMPONENT_LOTS_TOOLTIP_MESSAGE = 'Kit components cannot be assigned to lots.';
export const LOT_ASSIGNED_TOOLTIP_MSG = 'Pricing can be managed in the lot this item is assigned to.';
export const LOT_ASSIGNED_KIT_MAIN_LINE_ITEM = 'Pricing can be managed in the lot this kit is assigned to.';
export const LEAD_TIME_VALUE_TOOLTIP_MSG = `Change lead time unit 'In Stock' to other value. `;
export const ADD_DEDUCT_AMOUNT_TOOLTIP_MESSAGE = 'Add/Deduct Amount is auto-calculated based on pricing of the option and of the product it is replacing.';
export const WARNING_TOOLTIP = 'Hidden columns still impact calculations and can appear in documents. Hiding this column may cause confusion as it contains data.';
export const EXTENDED_COST_TOOLTIP_MSG = 'Extended Cost is auto-calculated based on Qty, Cost and Per.';
// This is the sum of width occuiped by columns drag + checkbox + kits + menu+ qty
export const PINNED_AND_FIX_COLUMN_WIDTH = 400;
